export interface ScribeReadyInput {
  mediaDevices: readonly unknown[] | null;
  microphoneDeviceId: string | null;
  mediaRecorder: unknown | null;
  scribe: unknown | null;
}

export function isScribeReady({
  mediaDevices,
  microphoneDeviceId,
  mediaRecorder,
  scribe,
}: ScribeReadyInput): boolean {
  return (
    (mediaDevices?.length ?? 0) > 0 &&
    microphoneDeviceId !== null &&
    mediaRecorder !== null &&
    scribe !== null
  );
}
